module.exports = __webpack_public_path__ + "static/media/holly_randall.bf7df3e8.png";